;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabs = require("../mixins/tabs");

var _tabs2 = _interopRequireDefault(_tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    types: {
      type: Array,
      default: function _default() {
        return [{ name: "model", title: "По марке авто" }, { name: "params", title: "По параметрам" }, { name: "code", title: "По коду товара" }];
      }
    }
  },
  mixins: [(0, _tabs2.default)("types")]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ss-types"},[_c('div',{staticClass:"ss-types__header"},[_c('div',{staticClass:"ss-types__buttons"},_vm._l((_vm.types),function(type){return _c('button',{key:type.name,staticClass:"ss-types__button",class:{ 'is-active': type.name === _vm.current },attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle(type.name)}}},[_c('span',{staticClass:"ss-types__caption"},[_vm._v("Подобрать")]),_vm._v(" "),_c('span',{staticClass:"ss-types__title"},[_vm._v(_vm._s(type.title))])])}),0)]),_vm._v(" "),_c('div',{staticClass:"ss-types__body"},[_c('ul',{staticClass:"ss-types__list"},_vm._l((_vm.types),function(type){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(type.name === _vm.current),expression:"type.name === current"}],key:type.name,staticClass:"ss-types__item"},[_vm._t(type.name)],2)}),0)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74e259bd", __vue__options__)
  } else {
    hotAPI.reload("data-v-74e259bd", __vue__options__)
  }
})()}